import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PrerenderTags from '../../../components/Prerender';
import { useUserByUsername } from '../userQueries'; // @ts-expect-error cannot find module

import profileOpengraphSrc from 'bender-url!../../../../img/profile-opengraph.png';

const UserPrerender = ({
  username
}) => {
  const {
    user
  } = useUserByUsername(username);

  if (!user) {
    return null;
  }

  return /*#__PURE__*/_jsx(PrerenderTags, {
    title: [user.displayName, user.jobTitle].filter(Boolean).join(' - '),
    description: [user.displayName, user.jobTitle, user.company && user.company.name, user.biography, user.geolocation && user.geolocation.displayName].filter(Boolean).join(' - '),
    image: profileOpengraphSrc,
    type: "profile"
  });
};

export default UserPrerender;